import httpManager from "@/app/shared/utils/httpManager";

export async function fetchMonitorStats(monitorId) {
  const url = `/monitoring/users/${monitorId}/statistics/`;
  const response = await httpManager.get(url);
  return response.data;
}
